module.exports = __webpack_public_path__ + "img/installer-win-06.51357eb4.png";